var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9ebf20ab6dd433e6abe1837f4bbbc009a94fe72e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wallet@fuel-protocol"]={id:"9ebf20ab6dd433e6abe1837f4bbbc009a94fe72e"};
      